
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals",
      function () {
        return require("private-next-pages/deals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deals"])
      });
    }
  